import { fork } from "redux-saga/effects";

import { SagaWithReturnType } from "@multiweb/types/react";

/**
 * Spustí zadanou ságu, pokud je definovaná.
 * @param saga
 */
export const forkIfExists: SagaWithReturnType<[SagaWithReturnType?]> = function* forkIfExists(saga?) {
    if (saga) {
        yield fork(saga);
    }
};
